import {
  formatManagerInboxesNotification,
  getTimeDifference,
} from 'containers/AppContainer/utils';
import { get, isEmpty, isNil } from 'lodash';
import userPrivelges from 'containers/services/security/user-privileges';

export const getMaxNotificationTime = (
  managerNotifications: any,
  convertionInboxe: any,
  element: any,
) => {
  return (
    ((getTimeDifference(
      get(
        [
          ...formatManagerInboxesNotification(
            managerNotifications.filter(
              (el: any) =>
                el.managerNotificationType?.managerInboxesId !==
                Number(get(convertionInboxe, 'managerInboxesId')),
            ),
            managerNotifications.filter(
              (el: any) =>
                el.managerNotificationType?.managerInboxesId ===
                Number(get(convertionInboxe, 'managerInboxesId')),
            ),
          ),
        ].filter(
          (el: any) =>
            (Number(get(element, 'managerInboxe.id')) ===
              Number(el.managerNotificationType?.managerInboxesId) ||
              Number(get(element, 'transactionInboxeAreaId')) ===
                Number(el.transactionInboxeAreaId)) &&
            el.readBy === null,
        ),
        '[0].created_at',
      ),
    )?.days as unknown) as string) || '0'
  );
};

export const getMaxLawyerNotificationTime = (
  lawyerNotifications: any,
  element: any,
) => {
  return (
    ((getTimeDifference(
      get(
        lawyerNotifications.filter(
          (el: any) =>
            Number(get(element, 'id')) === Number(el.lawyerInboxeId) &&
            el.readBy === null,
        ),
        '[0].created_at',
      ),
    )?.days as unknown) as string) || '0'
  );
};

export const renderNotifications = (
  managerNotifications: any,
  convertionInboxe: any,
  userInboxesId: any,
  transactionInboxeAreaId: any,
) => {
  return [
    ...formatManagerInboxesNotification(
      managerNotifications?.filter(
        (el: any) =>
          el.managerNotificationType?.managerInboxesId !==
          Number(get(convertionInboxe, 'managerInboxesId')),
      ),
      managerNotifications.filter(
        (el: any) =>
          el.managerNotificationType?.managerInboxesId ===
          Number(get(convertionInboxe, 'managerInboxesId')),
      ),
    ),
  ].filter(
    (el: any) =>
      userInboxesId?.includes(el.managerNotificationType?.managerInboxesId) ||
      transactionInboxeAreaId?.includes(el.transactionInboxeAreaId),
  );
};

export const getCountNotifications = (
  managerNotifications: any,
  element: any,
) => {
  return !isEmpty(managerNotifications)
    ? [...managerNotifications].filter(
        (el: any) =>
          (get(element, 'managerInboxe.id') ===
            el.managerNotificationType?.managerInboxesId ||
            get(element, 'transactionInboxeAreaId') ===
              el.transactionInboxeAreaId) &&
          el.treatedBy === null &&
          el.readBy === null,
      ).length
    : 0;
};

export const getCountLawyerNotifications = (
  lawyerNotifications: any,
  element: any,
) => {
  return !isEmpty(lawyerNotifications)
    ? [...lawyerNotifications].filter(
        (el: any) =>
          get(element, 'id') === el.lawyerInboxeId && el.readBy === null,
      ).length
    : 0;
};

export const getTransactionInboxes = () => {
  return userPrivelges
    .getUserInboxes()
    .map((el: any) =>
      !isNil(el.transactionInboxeAreaId)
        ? el.transactionInboxeAreaId
        : undefined,
    )
    .filter((element: any) => element);
};

export const getInboxesId = () => {
  const userInboxesId =
    !isEmpty(userPrivelges.getUserInboxes()) &&
    userPrivelges.getUserInboxes()?.map((el: any) => el.managerInboxe.id);
  const transactionInboxeAreaId =
    !isEmpty(userPrivelges.getUserInboxes()) &&
    userPrivelges
      .getUserInboxes()
      ?.map((el: any) => el.transactionInboxeAreaId);
  return { userInboxesId, transactionInboxeAreaId };
};

export const getFeeNote = (
  currentNotificationId: number,
  lawyerNotifications: any,
  valueToGet: string,
  defaultValue: any,
) => {
  return get(
    lawyerNotifications.find((el: any) => el.id === currentNotificationId),
    valueToGet,
    defaultValue,
  );
};

export const sortLawyerNotificationsByInboxe = (
  inboxesLawyerNotifications: any,
  lawyerInboxeId: number,
) => {
  return inboxesLawyerNotifications
    .filter((el: any) => {
      return el.lawyerInboxeId === lawyerInboxeId;
    })
    .sort(
      (a: any, b: any) =>
        new Date(b.created_at).valueOf() - new Date(a.created_at).valueOf(),
    );
};
